$(document).ready(function () {
  //ipad,mobile side menu toggle
  if ($(".toggle-page-menu").length > 0) {
    $(document).on("click", ".toggle-page-menu", function () {
      $(this).toggleClass("active");
      $(this).closest("#ht-sidemenu").find(".page-nav").toggle();
    });
  }
});
//toggle mega menu class when mega menu item clicked
$(document).on("click", '[data-menu="main-menu"]', function () {
  $("body").toggleClass("mega-menu-open");
  /*let isOpen = $(this).find('.mega-menu').attr('open');
  setTimeout(function(){
    if(isOpen == true){
      $('body').addClass('mega-menu-open')
    }
    else{
      $('body').removeClass('mega-menu-open')
    }
  },100)*/
});

if($(document).find('.hrt-toggle-content').length > 0){
  $(document).on('click', '.hrt-read-more-toggle', function(){
    $(this).toggleClass('active');
    $('.hrt-toggle-content').toggle();
  })
}
